<template>
  <el-dialog
    title="Delete Subscription"
    :visible.sync="shouldShow"
    @close="closeEvent"
    width="30%"
  >
    <el-row type="flex">
      <el-col :span="24">
        <p>
          Are you sure you want to delete this subscription for
          <span class="text-bold text-grey-primary">{{
            subscriptionEmail
          }}</span>
          ?
        </p>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="closeEvent">Cancel</el-button>
      <el-button type="danger" :loading="deleting" @click="deleteSubscription"
        >Delete</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import subscriptions from "@/requests/subscriptions/subscription";

export default {
  name: "SubscriptionDelete",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    subscriptionEmail: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    closeEvent() {
      this.shouldShow = false;
      this.deleting = false;
    },
    deleteSubscription() {
      this.deleting = true;
      subscriptions
        .delete(this.subscriptionEmail)
        .then((response) => {
          if (response.data.status) {
            this.$message.success(response.data.message);
            this.$emit("success");
            this.closeEvent();
          }
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
          this.deleting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  line-height: 2;
}
</style>
